/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _columns;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import JournalEventModel from "core/models/journal-event";
import Patient from "core/models/patient";
import { getJesOfClass } from "core/utils/journal-events";
import { sortBy } from "core/utils/sort";
import { modifier } from "ember-modifier";
import JesHistoryTableColumnComponent from "./column";
import styles from "./index.module.css";
let JesHistoryTableComponent = (_class = (_columns = /*#__PURE__*/new WeakMap(), class JesHistoryTableComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "columns", _descriptor, this);
    _classPrivateFieldInitSpec(this, _columns, []);
    _initializerDefineProperty(this, "dropdownMenu", _descriptor2, this);
    _defineProperty(this, "setupColumns", modifier(this._setupColumns));
    _defineProperty(this, "setDropdownMenu", modifier(this._setDropdownMenu));
  }
  get patient() {
    return this.args.patient;
  }
  get jesByColumn() {
    const res = this.columns.map(column => {
      try {
        return [column, this.patient.get(column.patientRelationName)
        // This filter should probably be done elsewhere, maybe on the patient as we have `journalEvents` & `activeJournalEvents` or we can consider that all fetched JE are not archived ?
        .filter(je => !je.isArchived).sort(sortBy("occurredAt", "desc"))];
      } catch {
        return [column, getJesOfClass(this.patient.activeJournalEvents, column.jeClass)];
      }
    });
    return new Map(res);
  }
  get dates() {
    const timestamps = this.columns.flatMap(column => {
      const jes = this.jesByColumn.get(column);
      return jes.map(je => +je.occurredOn);
    });

    // map timestamps to unique, sorted
    return [...new Set(timestamps)].sort().reverse().map(ts => new Date(ts));
  }
  addColumn(column) {
    _classPrivateFieldGet(_columns, this).push(column);
  }
  _setupColumns() {
    this.columns = _classPrivateFieldGet(_columns, this);
  }
  _setDropdownMenu(el) {
    this.dropdownMenu = el;
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "columns", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dropdownMenu", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addColumn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_setupColumns", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setupColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_setDropdownMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setDropdownMenu"), _class.prototype), _class);
export { JesHistoryTableComponent as default };